import React from 'react'
import { useSearchParams } from 'react-router-dom'

import { PaginatedTable, PaginatedTableCallbacks, useTableUrlSync } from '../common'
import { InvoicesTable } from './collectionTable'
import { InvoiceFilters } from './filters'
import { Invoice, JsonInvoice } from '../../models'
import { getInvoices } from '../../api'
import { getAuthUser } from '../../helpers'
import defineAbilityFor from './defineAbility'
import { InsufficientPermissions } from '../common'

export const InvoicesLanding = () => {
    const ability = defineAbilityFor(getAuthUser())
    const [searchParams] = useSearchParams()
    const tableUrlSync = useTableUrlSync(['completed'])
    const supplierId = searchParams.get('supplierId')

    if (!ability.can('View', 'Invoice')) {
        return <InsufficientPermissions />
    }

    return (
        <PaginatedTable<Invoice, JsonInvoice>
            defaultFilters={tableUrlSync.defaultFilters}
            defaultSearch={tableUrlSync.defaultSearch}
            defaultPage={tableUrlSync.defaultPage}
            disableLastPageButton={true}
            Filters={InvoiceFilters}
            getData={(params) =>
                getInvoices({
                    ...params,
                    ...(supplierId ? { supplierId } : {}),
                    ...(tableUrlSync.sortBy ? { sortBy: tableUrlSync.sortBy } : {}),
                    ...(tableUrlSync.sortDirection
                        ? { sortDirection: tableUrlSync.sortDirection }
                        : {}),
                })
            }
            modelConstructor={(json: JsonInvoice) => new Invoice(json)}
            onParamsChange={tableUrlSync.onParamsChange}
            persistSearch={tableUrlSync.persistSearch}
            searchPlaceholder="Search by Invoice ID, Supplier Phone, Record ID, Total, or Confirmation Number"
            Table={(invoices: Invoice[], callbacks: PaginatedTableCallbacks) => (
                <InvoicesTable callbacks={callbacks} resources={{ invoices }} />
            )}
            title="Invoices"
        />
    )
}
